import React, { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import {
  Modal,
  Box,
  Button,
  Stack,
  Typography,
  Divider,
  IconButton,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Autocomplete,
  Grid,
  FormControlLabel,
  Paper,
  TableContainer
} from "@mui/material";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const RevenueCalculationModelPopup = (props) => {
  const initialValues = {
    programName: "",
    programId: "",
    isDonor: false,
    effectiveDate: moment(),
    endDate: moment("2099-12-31"),
    terms: 1,
    monthlyPercentages: Array(1).fill("")
  };

  useEffect(() => {
    console.log("programs in popup", props.programs);
  }, []);

  const [values, setValues] = useState(initialValues);
  // console.log(props?.metaData?.programName);
  // const [programsName, setProgramsName] = useState(
  //   props?.metaData?.programName?.length > 0 &&
  //     props?.metaData?.programName?.map((item, index) => {
  //       return { id: index + 1, name: item };
  //     })
  // );

  const [programsName, setProgramsName] = useState(
    props?.programs?.length > 0 &&
      props?.programs?.map((item) => {
        return { id: item.programId, name: item.programName };
      })
  );

  const handleChange = (field, value) => {
    console.log(field, value);
    setValues((prev) => {
      let newState = {
        ...prev,
        [field]: value || ""
      };

      if (field === "terms") {
        newState.monthlyPercentages = value ? Array(Number(value)).fill("") : [];
      }
      return newState;
    });
  };

  const handlePercentageChange = (index, value) => {
    const updatedPercentages = [...values.monthlyPercentages];
    updatedPercentages[index] = value;
    setValues((prev) => ({
      ...prev,
      monthlyPercentages: updatedPercentages
    }));
  };

  const handleClose = () => {
    setValues(initialValues);
    props.handleClose();
  };

  const handleSubmit = () => {
    // const programSelected = programsName?.find((item) => item.name === values.program);
    console.log("monthlyPercentages: ", values.monthlyPercentages);
    const payload = {
      programId: values.programId || "",
      programName: values.programName || "",
      isDonor: values.isDonor ? "Y" : "N",
      effectiveDate: values.effectiveDate
        ? moment(dayjs(values.effectiveDate).toDate()).format("YYYY-MM-DD")
        : "",
      endDate: values.endDate ? moment(dayjs(values.endDate).toDate()).format("YYYY-MM-DD") : "",
      terms: values.terms?.toString() || "0",
      termMonthPercent: values.monthlyPercentages.map((percent, index) => ({
        term: (index + 1).toString(),
        monthPercent: Number(percent) || 0
      }))
    };
    props.handleSave(payload);
    handleClose();
    setValues(initialValues);
  };

  useEffect(() => {
    if (props.edit && props.data) {
      const {
        programName,
        isDonor,
        effectiveDate,
        endDate,
        terms,
        termMonthPercent = []
      } = props.data;

      const termsCount = Number(terms) || 1;

      const monthlyPercentages = Array(termsCount).fill("");

      termMonthPercent.forEach((item) => {
        const termIndex = Number(item.term) - 1;
        if (termIndex >= 0 && termIndex < termsCount) {
          monthlyPercentages[termIndex] = item.monthPercent;
        }
      });

      setValues({
        programName: programName || "",
        isDonor: isDonor === "Y",
        effectiveDate: effectiveDate ? moment(effectiveDate) : moment(),
        endDate: endDate ? moment(endDate) : moment("2099-12-31"),
        terms: termsCount,
        monthlyPercentages
      });
    } else {
      setValues(initialValues);
    }

    if (props?.programs?.length > 0) {
      // setProgramsName(
      //   props?.metaData?.programName?.map((item, index) => ({
      //     id: index + 1,
      //     name: item
      //   }))
      // );
      setProgramsName(
        props?.programs?.map((item) => ({
          id: item.programId,
          name: item.programName
        }))
      );
    }
  }, [props]);

  const termsOptions = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
    27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
    51, 52, 53, 54, 55, 56, 57, 58, 59, 60
  ];

  const totalPercentage = values.monthlyPercentages.reduce(
    (sum, val) => sum + (Number(val) || 0),
    0
  );

  const isOver100 = totalPercentage > 100;

  return (
    <Modal open={props.open}>
      <Box
        className="modal-style"
        sx={{
          width: "50%",
          maxHeight: "70vh",
          overflowY: "auto",
          backgroundColor: "white"
          // padding: 3,
          // borderRadius: 2,
          // position: "absolute"
          // top: "50%",
          // left: "50%",
          // transform: "translate(-50%, -50%)"
        }}>
        <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
          <Typography>
            {props.edit ? "Edit Revenue Calculation" : "New Revenue Calculation"}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Stack>

        <Divider sx={{ backgroundColor: "#177483", my: 1 }} />

        <Stack spacing={2} sx={{ mt: 2 }}>
          {/* Program */}
          <Stack direction="row" className="modal-stack">
            <Grid item xs={3.5}>
              <InputLabel>Program*</InputLabel>
            </Grid>
            {/* <Select
              fullWidth
              id="program"
              name="program"
              sx={{ minWidth: 300 }}
              // getOptionLabel={(option) => option.toString()}
              required
              value={values.programName}
              onChange={(e) => handleChange("programName", e.target.value)}>
              {programsName?.length > 0 &&
                programsName.map((prog) => (
                  <MenuItem key={prog.id} value={prog.name}>
                    {prog.name}
                  </MenuItem>
                ))}
            </Select> */}
            <Select
              fullWidth
              id="program"
              name="program"
              sx={{ minWidth: 300 }}
              required
              value={values.programName}
              onChange={(e) => {
                const selectedProgram = programsName.find((prog) => prog.name === e.target.value);
                if (selectedProgram) {
                  handleChange("programName", selectedProgram.name);
                  handleChange("programId", selectedProgram.id);
                }
              }}>
              {programsName?.length > 0 &&
                programsName.map((prog) => (
                  <MenuItem key={prog.id} value={prog.name}>
                    {prog.id} - {prog.name}
                  </MenuItem>
                ))}
            </Select>
          </Stack>

          {/* Donor */}
          <Stack direction="row" className="modal-stack">
            <Grid item xs={3.5}>
              <InputLabel>Donor</InputLabel>
            </Grid>
            <FormControlLabel
              value="start"
              style={{ marginRight: "73%", display: "inline-block" }}
              control={
                <Checkbox
                  color="primary"
                  name="donor"
                  value={values.isDonor}
                  checked={values.isDonor}
                  onChange={(e) => handleChange("isDonor", e.target.checked)}
                />
              }
              labelPlacement="start"
            />
          </Stack>

          {/* Effective Date */}
          <Stack direction="row" className="modal-stack">
            <Grid item xs={3.5}>
              <InputLabel>Effective Date*</InputLabel>
            </Grid>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={values.effectiveDate}
                onChange={(newValue) => handleChange("effectiveDate", newValue || "")}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Stack>

          {/* End Date */}
          <Stack direction="row" className="modal-stack">
            <Grid item xs={3.5}>
              <InputLabel required>End Date</InputLabel>
            </Grid>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={values.endDate}
                onChange={(newValue) => handleChange("endDate", newValue || "")}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
          </Stack>

          {/* Terms */}
          <Stack direction="row" className="modal-stack">
            <Grid item xs={3.5}>
              <InputLabel>Terms (Months)*</InputLabel>
            </Grid>
            <Autocomplete
              fullWidth
              options={termsOptions}
              value={values.terms}
              onChange={(_, newValue) => handleChange("terms", newValue || "")}
              freeSolo
              getOptionLabel={(option) => option.toString()}
              renderInput={(params) => <TextField required {...params} type="number" fullWidth />}
            />
          </Stack>
        </Stack>

        <Grid item xs={3.5} style={{ marginTop: "20px" }}>
          <InputLabel>Monthly Percentages</InputLabel>
        </Grid>
        <Grid>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Month</TableCell>
                  <TableCell>% of Net Program Fee</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {values.monthlyPercentages.map((value, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={value || ""}
                        onChange={(e) => handlePercentageChange(index, e.target.value)}
                        inputProps={{
                          min: 0,
                          max: 100,
                          step: 0.01
                        }}
                        InputProps={{
                          sx: {
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0
                              },
                            "& input[type=number]": {
                              MozAppearance: "textfield"
                            }
                          }
                        }}
                        fullWidth
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 3 }}>
          {/* Left side: Total Percentages */}
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: isOver100 ? "red" : "inherit",
                fontWeight: "bold"
              }}>
              Total Percentage: {totalPercentage.toFixed(2)}%
              {isOver100 && (
                <Typography component="span" sx={{ color: "red", ml: 1 }}>
                  Total Percentage exceeds 100%!
                </Typography>
              )}
            </Typography>
          </Grid>

          {/* Right side: Buttons */}
          <Stack direction="row" spacing={2}>
            <Button variant="outlined" className="btn-primary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              className="btn-usf"
              onClick={handleSubmit}
              disabled={isOver100}>
              {props.edit ? "Save" : "Create"}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default RevenueCalculationModelPopup;
